import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

import * as _ from "lodash";

@Component({
  selector: "sort-radio-btns",
  templateUrl: "./sort-radio-btns.component.html",
  styleUrls: ["./sort-radio-btns.component.scss"],
})
export class SortRadioBtnsComponent implements OnInit {
  @Input() column;
  @Input() sortColumns;
  @Input() groupStatusSort;
  @Output() radioBtnSelected = new EventEmitter();

  constructor() {}
  sortVal;

  ngOnInit() {
    if (this.column && this.column.id == -1) {
      // for the group status column, we get the initial sort value from the groupStatusSort
      this.sortVal = this.groupStatusSort;
    } else {
      // for non-group status columns, we get the initial sort value from the sortColumns
      this.sortVal = this.getRadioBtnVal();
    }
  }

  sortValChanged(event) {
    this.radioBtnSelected.emit(event);
  }

  getRadioBtnVal() {
    if (this.sortColumns) {
      let sortColumn = _.find(this.sortColumns, [
        "student_kpi_id",
        this.column.id,
      ]);
      if (sortColumn) {
        return sortColumn["sort_ascending"] ? "ASC" : "DESC";
      } else {
        return "CLEAR";
      }
    } else {
      return "CLEAR";
    }
  }
}
